<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('adminList.adminName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginStatus')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('status.enable')" :value="1"></el-option>
								<el-option :label="$t('status.disable')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('adminList.belongTo')" class="mb-0">
							<el-select v-model="from.rule_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('adminList.addAdmin')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column>
				<el-table-column align="center" prop="name" width="100" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('adminList.adminName')">
				</el-table-column>
				<el-table-column align="center" prop="username" :label="$t('adminList.loginName')">
				</el-table-column>
				<el-table-column align="center" prop="status" :label="$t('adminList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('adminList.normalLogin') : $t('adminList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="admin_rule.name" :label="$t('adminList.belongTo')">
				</el-table-column>
				<el-table-column align="center" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'editAdmin'" @click="openModel(scope)">{{$t('adminList.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('adminList.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				layout="total, prev, pager, next, sizes, jumper"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('adminList.editAdmin') : $t('adminList.addAdmin')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'4'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('adminList.adminName')" prop="name">
					<el-input v-model="form.name" :placeholder="$t('adminList.adminName')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginName')" prop="username">
					<el-input v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('adminList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginPassword')" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginStatus')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('adminList.normalLogin')}}</el-radio>
						<el-radio :label="0" border>{{$t('adminList.forbidLogin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Admin',

				preUrl: "user/adminList", //列表地址
				delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAdmin", //删除單条地址
				addUrl: "user/addAdmin", //添加/修改地址
				editStatusUrl:"user/editStatusAdmin",//修改狀態地址

				tableData: [],
				form: {
					name: "",
					username: '',
					password: '',
					password2: '',
					headUrl: '',
					icon:'',
					status: 1,
					headId: 0,
					rule_id: ''
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('adminList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}, {
						min: 6,
						max: 16,
						message: this.$t('adminList.usernameLength'),
						trigger: 'blur'
					}],
					password: [{
						min: 6,
						max: 16,
						message: this.$t('adminList.passwordLength'),
						trigger: 'blur'
					}],
					rule_id: [{
						required: true,
						message: this.$t('adminList.ruleRequired'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			computedLeft() {
				return this.layout.isCollapse ? "64px" : "200px"; // ✅ 计算 left
			},
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['rule']);
		},
		methods: {
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('adminList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					if(!this.form.headUrl){
						this.$message.error(this.$t('adminList.upProfile'));
						return false
					}
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						icon:'',
						headId: 0,
						status: 1,
						rule_id: ''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						username: e.row.username,
						password: '',
						password2: '',
						headUrl: e.row.head,
						icon:e.row.head,
						headId: 0,
						status: e.row.status,
						rule_id: e.row.admin_rule.id,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule_list = list.rule

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 12;

				if (!isJPG) {
				this.$message.error(this.$t('message.info_err'));
				}
				if (!isLt2M) {
				this.$message.error(this.$t('message.img_max_err'));
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					rule_id:'',
					time:[],
					end_time:''
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
